$(document).ready(function () {
  // IDで対応する要素を配列化する
  const inspectionIDs = ['inspection'];
  const repairIDs = [
    'repair1',
    'repair2',
    'repair3',
    'repair4',
    'repair5',
    'repair6',
    'repair7',
    'repair8',
    'repair9',
  ];

  // inspection用 初期化処理
  inspectionIDs.forEach(id => {
    const $container = $(`#${id}`);
    const $fileInput = $container.find('input[type="file"]');
    const $imgWrap = $container.find('.l-form__inspection__img__wrap');

    $fileInput.on('change', function (event) {
      const file = this.files[0];
      if (!file) return;

      $imgWrap.empty(); // 既存の画像をクリア

      const $img = $('<img>', {
        class: 'l-form__inspection__img',
        alt: '車検証',
      });

      const reader = new FileReader();
      reader.onload = function (e) {
        $img.attr('src', e.target.result);
        $imgWrap.append($img);
      };
      reader.readAsDataURL(file);
    });
  });

  // repair用 初期化処理
  repairIDs.forEach(id => {
    const $container = $(`#${id}`);
    const $fileInput = $container.find('input[type="file"]');
    const $imgWrap = $container.find('.l-form__repair__img__wrap');

    $fileInput.on('change', function (event) {
      const file = this.files[0];
      if (!file) return;

      $imgWrap.empty(); // 既存の画像をクリア

      const $img = $('<img>', {
        class: 'l-form__repair__img',
        alt: '修理箇所の写真',
      });

      const reader = new FileReader();
      reader.onload = function (e) {
        $img.attr('src', e.target.result);
        $imgWrap.append($img);
      };
      reader.readAsDataURL(file);
    });
  });
});

document.addEventListener('DOMContentLoaded', function() {
  // フォーム要素を取得
  const form = document.querySelector('.wpcf7 form'); // フォームのセレクタを指定
  if (!form) return;

  // ラジオボタンと対象フィールドを取得
  const radioButtons = document.querySelectorAll('input[name="vehicle_information"]'); // ラジオボタン
  const targetField = document.querySelector('input[name="chassis_number"]'); // 必須項目

  if (!radioButtons.length || !targetField) return; // 要素が見つからない場合は終了

  // ラジオボタンの変更イベントを監視
  radioButtons.forEach(radio => {
    radio.addEventListener('change', function() {
      if (this.value === 'specific-value') { // 特定のラジオボタンが選択された場合
        targetField.removeAttribute('required'); // 必須属性を削除
      } else {
        targetField.setAttribute('required', 'required'); // 必須属性を追加
      }
    });
  });
});
